import { useEffect, useState } from "react"
import { getData } from "../../utils/apiCalls"
import { Counter } from "./Counter"
import { useGlobalState } from "../../hooks/useGlobalState"
import { ACTIONS } from '../../state';
import { countObjectsWithPropVal } from "../../utils/funcs";
import { svgs } from "../../assets/svgs";
import { Loader } from "../Loader";


export const TicketsForm = ({ formid }) => {
    const [data, setData] = useState({})
    const [isActive, setIsActive] = useState(false)
    const [showMoreIdxs, setShowMoreIdxs] = useState([])
    const [reloadForm, setReloadForm] = useState(false)
    const { cart, promoCode, dispatch, calculateTotal, price, discount } = useGlobalState()
    const promo_code = sessionStorage.getItem('promo')

    useEffect(() => {
        dispatch({ type: ACTIONS.SET, entity: 'promoCode', payload: promo_code || (discount ? "early" + discount : "") })
        setReloadForm(!reloadForm)
    }, [discount])

    useEffect(() => {
        getData(`https://youngstartup.io/api/cwebsite-reg/tickets_form/${formid}?promo=` + promoCode)
            .then(res => setData(res))
    }, [reloadForm])

    const handelDiscount = (e) => {
        e.preventDefault()
        if (!promoCode) return
        setIsActive(true)
        setTimeout(() => {
            setIsActive(false)
        }, 1000)
        setReloadForm(!reloadForm)
    }

    const handelClick = () => {
        if (!cart.length > 0) return
        dispatch({ type: ACTIONS.SET_MODAL_STATUS, payload: { modal: 'registerForm', status: true } })
    }

    const handelShowMore = (idx) => {
        setShowMoreIdxs(
            showMoreIdxs.includes(idx)
                ? showMoreIdxs.filter(i => i !== idx)
                : [...showMoreIdxs, idx]
        )
    }

    return (
        <>
            <div dangerouslySetInnerHTML={{ __html: data.header_text }}></div>
            {!data.tickets?.length > 0 && <Loader color='dark2' />}
            {data.tickets?.length > 0 &&
                <div className='tickets-form'>
                    <h1>Register Now</h1>
                    <header>
                        <h1>Ticket Type</h1>
                        <h1>Price</h1>
                        <h1>Amount</h1>
                    </header>
                    {data.tickets?.map((ticket, idx) =>
                        <main className={showMoreIdxs.includes(idx) ? 'show-more' : ''} key={idx}>
                            <h1 className='name'>{ticket.full_name}</h1>
                            <ul className='benefits'>{ticket.benefits?.map((b, idx) => <li key={b.id}>{b.name.replaceAll('*', '\n*')}</li>)}</ul>
                            <div className='price'>
                                <h1>${Math.abs((Number(ticket.cost) + Number(ticket.fees)) - (Number(ticket.promo_discount) * Number(ticket.increment_by))).toFixed(2)}</h1>
                                <h2>{`$${ticket.cost} + $${ticket.fees} fees`}</h2>
                            </div>
                            {ticket.sold_out &&<p className='counter'>Sold Out</p>}
                            {!ticket.sold_out && <Counter className='counter' min={0} max={ticket.max_per_person} num={countObjectsWithPropVal(cart, 'type_id', ticket.id)} ticket={ticket} />}
                            {ticket.benefits?.length > 0 && <button onClick={() => handelShowMore(idx)}>{showMoreIdxs.includes(idx) ? 'Hide' : 'Show Benefits'}</button>}
                        </main>
                    )}
                    <section className='promo'>
                        <form onSubmit={handelDiscount}>
                            <input onChange={(e) => dispatch({ type: ACTIONS.SET, entity: 'promoCode', payload: e.target.value })} placeholder='Promo Code' type="text" value={promoCode} />
                            <button className={isActive ? 'active' : ''}>Apply</button>
                        </form>
                        {promoCode && <h3>{data.is_valid_promo_code ? '*Apllied Successfully' : '*Promo Code Invalid'}</h3>}
                    </section>
                    <footer>
                        <button className={cart.length > 0 ? 'btn' : 'btn disabled'} onClick={handelClick}>Register Now</button>
                        <div>{svgs.visa} {svgs.mastercard} {svgs.discover} {svgs.amex}</div>
                    </footer>
                </div>}
        </>
    )
}